'use client'

import {Paper, SimpleGrid, Stack, Text} from '@blocks'

export const Why = () => {
   return (
      <Stack
         id={'why'}
         my={100}
         gap={20}
      >
         <Text
            c={'white'}
            fz={23}
            fw={650}
         >
            Why Kodra?
         </Text>
         <SimpleGrid cols={2}>
            <Paper
               p={20}
               bg={'transparent'}
               bd={'1px solid white'}
               withBorder={true}
            >
               <Text
                  c={'white'}
                  fz={18}
               >
                  Founder-led, hands-on technical leadership
               </Text>
            </Paper>
            <Paper
               p={20}
               bg={'transparent'}
               bd={'1px solid white'}
               withBorder={true}
            >
               <Text
                  c={'white'}
                  fz={18}
               >
                  Thoughtful design paired with robust engineering
               </Text>
            </Paper>
            <Paper
               p={20}
               bg={'transparent'}
               bd={'1px solid white'}
               withBorder={true}
            >
               <Text
                  c={'white'}
                  fz={18}
               >
                  Clear communication and low-friction collaboration
               </Text>
            </Paper>
            <Paper
               p={20}
               bg={'transparent'}
               bd={'1px solid white'}
               withBorder={true}
            >
               <Text
                  c={'white'}
                  fz={18}
               >
                  Solutions built for longevity, not shortcuts
               </Text>
            </Paper>
         </SimpleGrid>
      </Stack>
   )
}
